<template>
  <a-menu-item :key="menuInfo.key" v-bind="$props" v-on="$listeners" :disabled="menuInfo.disabled">
    <a v-if="menuInfo.url === 'store_url'" @click="openStore">
      <span :class="styles.title">{{ $t(`sideBar.${menuInfo.lang}`) }}</span>
      <!-- <span :class="styles.title">{{ menuInfo.key === 'order-list' && menuInfo.roles.includes('distributor') ? $t(`sideBar.orderListDistributor`) : $t(`sideBar.${menuInfo.lang}`) }}</span> -->
      <span v-if="menuInfo.count" class="badge badge-success ml-2">{{ menuInfo.count }}</span>
      <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]"></i>
    </a>
    <router-link v-if="menuInfo.url && menuInfo.url !== 'store_url'" :to="menuInfo.url">
      <!-- <span :class="styles.title">{{ $t(`sideBar.${menuInfo.lang}`) }}</span> -->
      <span :class="styles.title">{{ menuInfo.key === 'order-list' && isDistributor ? $t('sideBar.orderListDistributor') : $t(`sideBar.${menuInfo.lang}`) }}</span>
      <span v-if="menuInfo.count" class="badge badge-success ml-2">{{ menuInfo.count }}</span>
      <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]"></i>
    </router-link>
  </a-menu-item>
</template>

<script>
import { Menu } from 'ant-design-vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SubMenu',
  props: {
    ...Menu.Item.props,
    menuInfo: Object,
    styles: Object,
  },
  computed: {
    ...mapState('user', {
      store_url: state => state.store_url,
    }),
    ...mapGetters('user', ['isDropship', 'isDistributor']),
  },
  methods: {
    openStore () {
      window.open(this.store_url, '_blank')
    },
  },
}
</script>
